<template>
  <button
    :type="type"
    :class="[
      'flex size-8 items-center justify-center rounded-lg',
      'hover:bg-background-fg/3',
    ]"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{ type?: "button" | "submit" }>(),
  {
    type: "button",
  }
)
</script>
